'use strict';
import {ToastService} from './ToastService';

/**
 * Module dependencies
 */
const angular = require('angular');

module.exports = angular
  .module('app.components.toast-messages', [])
  .constant('TOAST_TYPES', require('./TOAST_TYPES.js'))
  .service('$toast', ToastService)
;



// WEBPACK FOOTER //
// ./src/js/core-components/toast-messages/index.js